import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aot-mobile',
  templateUrl: './aot-mobile.component.html',
  styleUrls: ['./aot-mobile.component.scss']
})
export class AotMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
